import React from 'react';
import { withRouter } from 'react-router';
import { AdminPageShell } from '../../components/admin/Shared';
import RegisterSection, {
  RegistrationProps,
} from '../../components/RegisterSection';

function AdminUsersCreateComponent(props: RegistrationProps): JSX.Element {
  return (
    <AdminPageShell
      variant="form"
      title="New admin"
      onBack={() => props.history.push('/admin/users')}
    >
      <RegisterSection
        {...props}
        postRegistration={() => {
          props.history.push('/admin/users');
        }}
        path="/users/create"
        createAdminAccount={true}
      />
    </AdminPageShell>
  );
}

export default withRouter(AdminUsersCreateComponent);
